import React, { Component } from "react";
import {Container,Row,Col,Button, Form, FormGroup, Label, Input ,Modal,ModalBody,DropdownItem,DropdownMenu,UncontrolledDropdown,DropdownToggle } from 'reactstrap';
import httpClient from '../../httpClient'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  faAngleDown, faAngleLeft, faAngleRight,faPlus
 } from '@fortawesome/free-solid-svg-icons'
 import data from '../data/data.json'
 import { connect } from 'react-redux';
import { addCar, addCarPhotos } from "../../slices/modalSlice";
// import AddImages from "./addImages";


class AddAnnounceCar extends Component {
    constructor(props) {
        super(props);
        this.state = {
          announceCarInfo: {
            title: "",
            pays: "Algérie",
            region: "Alger",
            commune: "Bab El Oued",
            marque: "Renault",
            modele: "Clio",
            energie: "Diesel",
            moteur: "1.9D",
            transmission: "Manuelle",
            annee: "2020",
            kilometrage: "",
            couleur: "",
            nbrPortes: 4,
            nbrSiege: 4,
            options: [],
            type:"Citadine",
            infoComplementaire: "",
            files : [],
            parJrs: { prix: 500, currancy: "DZD", distMAx: 10, fraisSupp: 100 },
            parSemaine: {
              prix: 1000,
              currancy: "DZD",
              distMAx: 10,
              fraisSupp: 100,
            },
            parMois: {
              prix: 1500,
              currancy: "DZD",
              distMAx: 10,
              fraisSupp: 100,
            },
          },
          openImagCar : false,
          availableCities: [],
          availableDairas: [],
          wilayaId: 15,
          imgUrl:[],
          alertMaxPic : false,
        };
         this.getData_dropDown = this.getData_dropDown.bind(this)
         this.toogleClosePhotos = this.toogleClosePhotos.bind(this);   

    }

    toogleClosePhotos =()=> this.props.dispatch(addCarPhotos())

    onInputChange(evt) {
      //if checkbox or input txt,num....
        if(evt.target.type !== "checkbox"){
          let name = evt.target.name
          let timeUnit =  evt.target.attributes.data || {value : ""}
          //we need to update object include in object
          if (timeUnit.value === "parJrs" || timeUnit.value === "parSemaine"|| timeUnit.value === "parMois") {
            this.setState({
              announceCarInfo: {
                  ...this.state.announceCarInfo,
                  [timeUnit.value]: {
                     ...this.state.announceCarInfo[timeUnit.value],
                     [name]: evt.target.value.toLowerCase()

                  }
              }
            })
          }else
          this.setState({
            announceCarInfo: {
                ...this.state.announceCarInfo,
                [name]: evt.target.value.toLowerCase()
            }
          })
        }
        else if(evt.target.type === "checkbox" ){
          const value = evt.target.nextSibling.data.toLowerCase();
          this.setState({
            announceCarInfo: {
                  ...this.state.announceCarInfo,
                  options: [...this.state.announceCarInfo.options,value.replaceAll(' ',"+")]
              }
              })
        }}
          
          toogleClose = () =>{
            this
            .props
            .dispatch(addCar())
          }
      

          postAnnounceCar(evt){
            evt.preventDefault()
            const idOwner = this.props.ownerId
            const typeAnnounce = "Voiture"
            const files = this.state.announceCarInfo.files
            const info = this.state.announceCarInfo
            info.type = this.props.carType.toLowerCase()
            httpClient.createCarAnnouce(info,idOwner,typeAnnounce,files).then(sent => {
              if (sent) {
                this.toogleClose();
                this.props.dispatch(addCarPhotos());
                this.setState({ announceCarInfo: {title: '', pays:"Algeriee" , region:"Alger", commune:"", marque:"Renault", modele:"Clio", energie:"Diesel", type:"4x4", transmission:"", annee:"", kilometrage:"", couleur:"", nbrPortes:4,nbrSiege:4, options:[], infoComplementaire:"",
                    parJrs:{prix:500,currancy:"DZD",distMAx:10,fraisSupp:100},
                    parSemaine:{prix:1000,currancy:"DZD",distMAx:10,fraisSupp:100},
                    parMois:{prix:1500,currancy:"DZD",distMAx:10,fraisSupp:100},
                }
                  })
              }
              else
               alert('Error')

                
                  })
        }

        getData_dropDown(e,wilaya,id){
            e.preventDefault()
            this.setState({
                announceCarInfo: {
                ...this.state.announceCarInfo,
                [e.currentTarget.name]: wilaya?.toLowerCase() || e.currentTarget.textContent.toLowerCase()
              },
              wilayaId:id||this.state.wilayaId
            }); 
          }

          onChangeUpload(e) {
            if (this.state.imgUrl.length<=4) {
              this.setState({files:e.target.files[0]});
           e.preventDefault();
        
           const file =  e.target.files[0]
        
           this.setState({
            announceCarInfo: {
              ...this.state.announceCarInfo,
              files: [...this.state.announceCarInfo.files,file]
          }
        })
        
           const fileReader = new FileReader();
           fileReader.onload = () => {
           this.setState({imgUrl: [...this.state.imgUrl,fileReader.result]});
           }
           fileReader.readAsDataURL(file);
          }
        
            else(
              this.setState({
                alertMaxPic : true
              })
            )
        }
           


    render() {
      const carType = ["Mini Citadine","Citadine","Berline","Moyenne Berline","SUV Tout-terrain","Grande Berline","Break Familliale","Coupé Cabriolet","Van","Mini Bus","Bus / Navette"]
      const carTypeeElm = [] ;
      const restitution = ["Restitution dans un endroit différent","Sans Chauffeur seulement","avec Chaufeur seulement","Conducteur entre 30 et 65 ans"]
      const restitutionElm = []

      carType.forEach(elm =>{
        carTypeeElm.push(
          <DropdownItem name="type" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>{elm}</DropdownItem>
          )
        })
      restitution.forEach(elm=>{
          restitutionElm.push(
            <DropdownItem name="annulation" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>{elm}</DropdownItem>
            )
        })
      const wilayaNameItem = data.wilayas.map(function(item, i){
        return (
          <DropdownItem name="region" onClick={e=>this.getData_dropDown(e,item.name,i)}> <span>{i+1}</span> {item.name}</DropdownItem>
        )
        },this)

        const dairasNameItem = data.wilayas[this.state.wilayaId].dairas.map(function(item, i){
          return (
            <DropdownItem name="commune" onClick={e=>this.getData_dropDown(e,item.name,i)}> <span>{i+1}</span> {item.name}</DropdownItem>
            )
          },this)


          const imag0 = this.state.imgUrl[0]
          const imag1 = this.state.imgUrl[1]
          const imag2 = this.state.imgUrl[2]
          const imag3 = this.state.imgUrl[3]
          const imag4 = this.state.imgUrl[4]

        const {title, pays , region, commune, marque, modele, energie, type, transmission, annee, kilometrage, couleur, nbrPortes,nbrSiege, infoComplementaire,parJrs,parSemaine,parMois } = this.state.announceCarInfo
        return ( 
          <>
            <Modal isOpen={this.props.addCar}  className="modal-width-details-announce">
            <nav className="nav-windows-addanounce">
            <button className="close-heberg"  onClick={this.toogleClose} >
              <span>X</span>
            </button>
            <div className="title-announce" >
              Nouvelle Annonce Location-Voiture
            </div>
            </nav>
            <div className="path-add-announce"></div>
            <ModalBody>
            <div className="line-after-path"></div>
                <Container>
                  <div className="custom-container">
                  <Form onChange={this.onInputChange.bind(this)} onSubmit={this.postAnnounceCar.bind(this)}>
  
                    <Row   className="second-Row">
                     <Col sm="1" id="label-title-input"><label>Titre</label></Col>
                     <Col sm="10"><Input type="text" name="title" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={title} required></Input></Col>
                    </Row>
  
  
                    <Row   className="second-Row">
                      <Col sm="3">
                        <Row>
                        <Col sm="2" id="label-title-input"><label>Pays</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {pays}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px",overflowY: "scroll" }}>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="4">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Region</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           {region}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px",overflowY: "scroll" }}>
                            {wilayaNameItem}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col> 
  
                      <Col sm="5">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Commune</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           {commune}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px",overflowY: "scroll" }}>
                              {dairasNameItem}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                    </Row>
  
                    <Row   className="second-Row">
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Marque</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {marque}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Renault</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Mercedes</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Peugeot</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>BMW</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Volswagen</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Modéle</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {modele}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="modele" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Octavia</DropdownItem>
                              <DropdownItem name="modele" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Clio3</DropdownItem>
                              <DropdownItem name="modele" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>AMG</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Energie</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           {energie}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="energie" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Essence</DropdownItem>
                              <DropdownItem name="energie" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Diesel</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col> 
  
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Type</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           {type}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              {carTypeeElm}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                    </Row>
  
                    <Row   className="second-Row">
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Transmission</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {transmission}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Manuel</DropdownItem>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Automatique</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Année</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {annee}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2012</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2013</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2014</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2015</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2016</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2017</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2018</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2019</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2020</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2021</DropdownItem>


                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="6">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Kilométrage</label></Col>
                         <Col>
                         <Input type="text" name="title" placeholder="200.000Km" className="title-announce-input" value={kilometrage} required></Input>
                         </Col>
                        </Row>
                      </Col>
  
                    </Row>
  
  
                    <Row   className="second-Row">
                      <Col sm="4">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Couleur</label></Col>
                         <Col>
                         <Input type="text" name="couleur" placeholder="Couleur" className="title-announce-input" value={couleur} required></Input>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="4">
                        <Row>
                        <Col sm="6" id="label-title-input"><label>Nombre de Portes</label></Col>
                         <Col>
                         <Input type="text" name="nbrPortes" placeholder="Nombre de Portes" className="title-announce-input" value={nbrPortes} required></Input>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="4">
                        <Row>
                        <Col sm="6" id="label-title-input"><label>Nombre de siéges</label></Col>
                        <Col>
                         <Input type="text" name="nbrSiege" placeholder="Nombre de Siege" className="title-announce-input" value={nbrSiege} required></Input>
                         </Col>
                        </Row>
                      </Col>
  
                    </Row>
                    <div className="line-after-path second-Row"></div>
  
                    <Row className="second-Row">
  
                      <Col sm="4">
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Direction Assistée</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Climatisation</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />ABS</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />ESP</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Vitres électrique Av</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Vitres électrique Ar</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Vitres Teintés</Label></FormGroup>
                      </Col>
  
                      <Col sm="4">
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Régalateur de Vitesse</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Radar de Calcul</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Alarme</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Ordinateur de Bord</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />GPS</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Toit Ouvrant</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Chargement Sans-Fil</Label></FormGroup>
                      </Col>
  
                      <Col sm="4" className="column-equipement">
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Siége Bébé</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Siége Chauffants</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Prises USB</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Prise Jack 3.5mm</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Clim.BI-Directionnelle</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Réfrigerateur</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Démarage a Boutin</Label></FormGroup>
                      </Col>
  
                    </Row>
  
                    <Row   className="second-Row">
                     <Col sm="3" id="label-title-input"><label>Information complémentaires</label></Col>
                     <Col ><Input type="textarea" name="infoComplementaire" placeholder="Equipement non-cités" className="text-area-descr" value={infoComplementaire} required></Input></Col>
                    </Row>
  
                    <div className="line-after-path second-Row"></div>
  
                    <Row className="second-Row">
                    <Col sm="2"><label>Prix</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parJrs" name="prix" value={parJrs.prix} required/></Col>
                    <Col sm="4">
                      <UncontrolledDropdown nav >
                           <DropdownToggle className="button-prix-announce">
                           {parJrs.currancy}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>DZD</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>EUR</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>US</DropdownItem>
                            </DropdownMenu>
                            /jour
                          </UncontrolledDropdown>
                      </Col>
                      <Col sm="3">
                        <label>Dist.Max</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data='parJrs' name="distMAx" value={parJrs.distMAx} required/>
                      </Col>
                      <Col sm="3">
                        <label>Frais Supp</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data='parJrs' name="fraisSupp" value={parSemaine.fraisSupp} required/>/Km
                      </Col>
                    </Row>
  
                    <Row className="second-Row">
                    <Col sm="2"><label>Prix</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" name="prix" data="parSemaine" value={parSemaine.prix} required/></Col>
                    <Col sm="4">
                      <UncontrolledDropdown nav >
                           <DropdownToggle className="button-prix-announce">
                           {parSemaine.currancy}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>DZD</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>EUR</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>US</DropdownItem>
                            </DropdownMenu>
                            /semaine
                          </UncontrolledDropdown>
                      </Col>
                      <Col sm="3">
                        <label>Dist.Max</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parSemaine" name="distMAx" value={parSemaine.distMAx} required/>
                      </Col>
                      <Col sm="3">
                        <label>Frais Supp</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parSemaine" name="fraisSupp" value={parSemaine.fraisSupp} required/>/Km
                      </Col>
                    </Row>
  
                    <Row className="second-Row">
                    <Col sm="2"><label>Prix</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parMois" name="prix" value={parMois.prix} required/></Col>
                    <Col sm="4">
                      <UncontrolledDropdown nav >
                           <DropdownToggle className="button-prix-announce">
                           {parMois.currancy}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>DZD</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>EUR</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>US</DropdownItem>
                            </DropdownMenu>
                            /mois
                          </UncontrolledDropdown>
                      </Col>
                      <Col sm="3">
                        <label>Dist.Max</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parMois" name="distMAx" value={parMois.distMAx} required/>
                      </Col>
                      <Col sm="3">
                        <label>Frais Supp</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parMois"  name="fraisSupp" value={parMois.fraisSupp} required/>/Km
                      </Col>
                    </Row>
                    
                    <Row className="second-Row">
                      <Col sm="6">
                      <label>Location avec Chauffeur</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" name="prix"  required/>
                      </Col>
                      <Col sm="6">
                      <label>Frais de restitution a un endroit différent</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" name="prix"  required/>/Km
                      </Col>
                    </Row>
  
                    <Row className="second-Row">
                      <Col sm="3"></Col>
                      <Col sm="4"><label className="">Frais de restitution a un endroit différent</label></Col>
                      <Col sm="5">
                      <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce" >
                            Remboursable
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              {restitutionElm}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                      </Col>
                    </Row>
  
  
  
  
                    <div className="line-after-path second-Row"></div>
  
  
                    <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Je confirme que toutes les informations déclarées sont correctes,j'assume toute déclaration (Champ Obligatoie)</Label></FormGroup>
                    <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Je souhaite vérifier mon annonce afin de bénificier des avantages de la platforme Ghurfaty (Badges,"Vérifié",Code Promo..)</Label></FormGroup>
  
                    <div className="buttons-details-announces">
                    <Button className=" button-add-moule retour-button"><FontAwesomeIcon id="arrow-retour"  icon={faAngleLeft} />Retour</Button>
                    <Button className=" button-add-moule suivant-button" onClick={this.toogleClosePhotos.bind(this)}>Suivant<FontAwesomeIcon id="arrow-suivant"  icon={faAngleRight} /></Button>
                    </div>
  
                  </Form>
                  </div>
                </Container>
              </ModalBody>
            </Modal>
            <Modal isOpen={this.props.addCarPh} toggle={this.toogleClosePhotos}  className="modal-width-images-announce">
        <nav className="nav-windows-addanounce">
        <button className="close-heberg"  onClick={this.toogleClosePhotos} >
          <span>X</span>
        </button>
        <div className="title-announce" >
          Nouvelle Annonce Location
        </div>
        </nav>

        <div className="path-heberg">
          <div className="item-path-hebrg" >

          <div className="number-path">
            <span className="number-path-value">1</span>
          </div>

          <span className="name-path" >
              Détails
              <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

          </span>

          </div>

          <div className="item-path-hebrg" style={{backgroundColor:"#37296a"}}>

             <div className="number-path" style={{backgroundColor:"white"}} >
               <span className="number-path-value" style={{color:"#37296a"}} >2</span>
             </div>

            <span className="name-path" style={{color:"white"}}>
                Photos
                <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

            </span>

         </div>

         <div className="item-path-hebrg">

             <div className="number-path">
               <span className="number-path-value">3</span>
             </div>

            <span className="name-path last-path">
                Agenda
                <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

            </span>
         </div>
        </div>

        <ModalBody style={{marginTop:"100px"}}>
        <Container>
              <Row>
                <Col md="7" className="pr-2">
                  <div className="img-ann" style={{width:"100%",height:"400px"}}>
                    {
                      imag0 &&
                      <>
                        <img src={this.state.imgUrl[0]} className="exs-main-img" alt=""/>
                      </>
                    }

                   {
                      !imag0 &&
                      <div className="img-holder">
                        <img src="/imgs/dashboard/add.svg" className="add-main-img" alt=""/>
                      </div>
                    }

                  </div>
                </Col>

                <Col md="5">

                  <Row className="row-half-height mb-2">
                    <Col sm="6" className="px-2">
                    {
                      imag1 &&
                      <>
                        <img src={this.state.imgUrl[1]} className="exs-img" alt=""/>
                      </>
                    }

                   {
                      !imag1 &&
                      <div className="img-holder">
                        <img src="/imgs/dashboard/add.svg" className="add-img" alt=""/>
                      </div>
                    }                    
                    </Col>

                    <Col sm="6" className="pdt px-2">
                    {
                      imag2 &&
                      <>
                        <img src={this.state.imgUrl[2]} className="exs-img" alt=""/>
                      </>
                    }

                   {
                      !imag2 &&
                      <div className="img-holder">
                        <img src="/imgs/dashboard/add.svg" className="add-img" alt=""/>
                      </div>
                    }                    
                    </Col>
                  </Row>
                  
                  <Row className="row-half-height">
                  <Col sm="6" className="pdt px-2">
                  {
                      imag3 &&
                      <>
                        <img src={this.state.imgUrl[3]} className="exs-img" alt=""/>
                      </>
                    }

                   {
                      !imag3 &&
                      <div className="img-holder">
                        <img src="/imgs/dashboard/add.svg" className="add-img" alt=""/>
                      </div>
                    }                  
                    </Col>
                  <Col sm="6" className="pdt px-2">
                  {
                      imag4 &&
                      <>
                        <img src={this.state.imgUrl[4]} className="exs-img" alt=""/>
                      </>
                    }

                   {
                      !imag4 &&
                      <div className="img-holder">
                        <img src="/imgs/dashboard/add.svg" className="add-img" alt=""/>
                      </div>
                    }                   
                    </Col>
                  </Row>

                </Col>

              </Row>

              <center className="files-upload-btn">

              <form  enctype="multipart/form-data">

                 <label for='upload-photo' className="button-add-moule add-imgs-button" > <span id="ajouter-text"><FontAwesomeIcon  icon={faPlus} />Ajouter des photos</span></label>
                 {this.state.imgUrl.length >= 5 && <p style={{color:"red"}}>Max 5 photos</p>}
                 <input type="file" name="myImage[]" id="upload-photo" disabled={this.state.imgUrl.length >= 5}
                 onChange={this.onChangeUpload.bind(this)} 
                 />
                 {/* <input type="text" name="imageUrl" placeholder="image url" /> */}

              </form>
              </center>

              <br/> <br/>
              <h6 style={{color:"rgb(119, 113, 113)"}}>Ps : Vous pouvez télecharger jusqu'a 4 photos a la fois ,sous formats JPEG,PNG,BMP ou TIFF</h6>
              <Row>
                <div className="buttons-add-announce-photos">
                  <Button className=" button-add-moule retour-button" onClick={this.retourAddHeberg}><FontAwesomeIcon id="arrow-retour"  icon={faAngleLeft} />Retour</Button>
                  <Button className=" button-add-moule suivant-button" 
                      onClick={this.postAnnounceCar.bind(this)}
                  >Valider<FontAwesomeIcon id="arrow-suivant"  icon={faAngleRight} /></Button>
                </div>
              </Row>
            </Container>
        </ModalBody>
        </Modal>
            </>
         );
    }
}
 


function mapStateToProps(state) {
  return {
    
    addCar: state.modal.addCar,
    ownerId : state.user.user._id,
    addCarPh : state.modal.addCarPh,
    carType : state.modal.carType

  }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(AddAnnounceCar);